import { getWithToken } from './http-client';

export default {
  enviarMail(hashReserva, token) {
    return getWithToken(`${process.env.RAZZLE_GATEWAY_MUNDIGEA}/mail/enviar-mail-reserva/${hashReserva}`, token)
      .then((res) => res.data);
  },
};
